/**
 * Panneau d'aide listant des extraits de code inserables.
 *
 * Remplace une fenetre modale ecrite a la main en styles en ligne, qui ne se
 * fermait pas avec la touche Echap, ne retenait pas le focus, laissait la page
 * defiler derriere elle et entrait en conflit de superposition avec le bouton
 * d'enregistrement flottant du mode administration.
 */

import React from 'react';
import { Drawer, Empty, List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { HtmlCssHelpItem } from '../core/types';

interface HelpDrawerProps {
  open: boolean;
  title: string;
  items: HtmlCssHelpItem[];
  onClose: () => void;
  onSelect: (code: string) => void;
}

const HelpDrawer: React.FC<HelpDrawerProps> = ({ open, title, items, onClose, onSelect }) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={title}
      open={open}
      onClose={onClose}
      placement="right"
      width={360}
      className="htmlcss-help-drawer"
    >
      {items.length === 0 ? (
        <Empty description={t('htmlCss.help.empty')} />
      ) : (
        <List
          dataSource={items}
          renderItem={item => (
            <List.Item
              className="htmlcss-help-item"
              onClick={() => onSelect(item.code)}
              // L'element est actionnable : il doit l'etre aussi au clavier.
              role="button"
              tabIndex={0}
              onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onSelect(item.code);
                }
              }}
            >
              <List.Item.Meta
                title={<Typography.Text strong>{item.label}</Typography.Text>}
                description={<pre className="htmlcss-help-code">{item.code}</pre>}
              />
            </List.Item>
          )}
        />
      )}
    </Drawer>
  );
};

export default HelpDrawer;
